.progress {
  &.success {
    :global(.ant-progress-track) {
      background-color: var(--rc-theme-color-success-default);
    }
  }

  &.error {
    :global(.ant-progress-track) {
      background-color: var(--rc-theme-color-error-default);
    }
  }

  &.warning {
    :global(.ant-progress-track) {
      background-color: var(--rc-theme-color-warning-default);
    }
  }
}
